:root ._dsp-flex{display:flex;}
:root ._items-stretch{align-items:stretch;}
:root ._fd-column{flex-direction:column;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._pos-relative{position:relative;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._minH-80px{min-height:80px;}
:root ._minH-0px{min-height:0px;}
:root ._gap-t-space-lar102228{gap:var(--t-space-larger);}
:root ._fd-row{flex-direction:row;}
:root ._gap-t-space-med104641{gap:var(--t-space-medium);}
:root ._items-center{align-items:center;}
:root ._width-10037{width:100%;}
:root ._fwr-wrap{flex-wrap:wrap;}
:root ._gap-t-space-sma3456{gap:var(--t-space-small);}
:root ._justify-flex-start{justify-content:flex-start;}
:root ._mt-t-space-sma3456{margin-top:var(--t-space-small);}
:root ._shrink-1{flex-shrink:1;}
:root ._grow-1{flex-grow:1;}
:root ._justify-space-betwe3241{justify-content:space-between;}